import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import JobSyndicationPage from "@/pages/admin/JobSyndicationPage";

export const Route = createFileRoute("/_admin/admin/job-boards")({
  head: () => pageHead("Admin · Job Boards", "Admin · where job openings are posted.", "/admin/job-boards", true),
  component: JobSyndicationPage,
});
